/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpdateUserPermissionRelationDto,
    UpdateUserPermissionRelationDtoFromJSON,
    UpdateUserPermissionRelationDtoFromJSONTyped,
    UpdateUserPermissionRelationDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserPermissionRelationsCommand
 */
export interface UpdateUserPermissionRelationsCommand {
    /**
     * 
     * @type {Array<UpdateUserPermissionRelationDto>}
     * @memberof UpdateUserPermissionRelationsCommand
     */
    relations?: Array<UpdateUserPermissionRelationDto> | null;
}

export function UpdateUserPermissionRelationsCommandFromJSON(json: any): UpdateUserPermissionRelationsCommand {
    return UpdateUserPermissionRelationsCommandFromJSONTyped(json, false);
}

export function UpdateUserPermissionRelationsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserPermissionRelationsCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relations': !exists(json, 'relations') ? undefined : (json['relations'] === null ? null : (json['relations'] as Array<any>).map(UpdateUserPermissionRelationDtoFromJSON)),
    };
}

export function UpdateUserPermissionRelationsCommandToJSON(value?: UpdateUserPermissionRelationsCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relations': value.relations === undefined ? undefined : (value.relations === null ? null : (value.relations as Array<any>).map(UpdateUserPermissionRelationDtoToJSON)),
    };
}


